// extracted by mini-css-extract-plugin
module.exports = {"blockquoteContainer":"styles_blockquoteContainer__18QEB","bq":"styles_bq__2K-lB","cite":"styles_cite__1kvno"};